var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLinkWhiteBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(6.500000, 6.500000) scale(-1, 1) translate(-6.500000, -6.500000) ",
    cx: 6.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,6.5 L9,6.5",
    id: "Line",
    stroke: "#FE5520",
    strokeLinecap: "round",
    transform: "translate(7.000000, 6.500000) scale(-1, 1) translate(-7.000000, -6.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,4 L7,6",
    id: "Line",
    stroke: "#FE5520",
    strokeLinecap: "round",
    transform: "translate(6.000000, 5.000000) scale(-1, 1) translate(-6.000000, -5.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,7 L7,9",
    id: "Line",
    stroke: "#FE5520",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLinkWhiteBack);
export default __webpack_public_path__ + "static/media/arrow-link-white-back.b6b20f53d69e41e78bf6c8d2a67dddd1.svg";
export { ForwardRef as ReactComponent };